<!-- Rückbau-Artikel Verwaltung - 50/50 Split mit AG-Grid Tabellen -->

  <!-- === Sektion A: Rückbau-Artikel === -->
  <div class="flex flex-col flex-1 min-h-0">
    <div class="flex items-center justify-between px-3 py-2">
      <h3 class="text-lg font-semibold">Rückbau-Artikel</h3>
      <button class="bm-btn bm-btn-primary bm-btn-sm" (click)="openNewForm()">
        <fa-icon [icon]="faPlus" class="mr-1" />
        Neuer Rückbau-Artikel
      </button>
    </div>

    <!-- AG-Grid: Rückbau-Artikel -->
    <div class="relative flex-1 min-h-0 px-3 pb-1">
      <ag-grid-angular
        class="ag-theme-quartz absolute inset-0 mx-3 mb-1"
        [rowData]="articles"
        [columnDefs]="articlesColDefs"
        [defaultColDef]="defaultColDef"
        [theme]="hawkTheme"
        [loadThemeGoogleFonts]="true"
        [localeText]="locale"
        [animateRows]="true"
        [suppressCellFocus]="true"
        (gridReady)="onArticlesGridReady($event)"
      />
    </div>
  </div>

  <!-- Trennlinie -->
  <div class="border-t border-base-300 mx-3"></div>

  <!-- === Sektion B: Klärfälle === -->
  <div class="flex flex-col flex-1 min-h-0">
    <div class="flex items-center gap-2 px-3 py-2 flex-wrap">
      <h3 class="text-lg font-semibold">Klärfälle</h3>
      @if (unclearRecords.length > 0) {
        <span class="bm-badge bm-badge-error">{{ unclearRecords.length }}</span>
      }
      <!-- Bulk-Löschen nach Zeitraum (created_at) — Eingabe im Popup. -->
      <div class="ml-auto">
        <button class="bm-btn bm-btn-sm bm-btn-error" (click)="openBulkDeleteDialog()">
          <fa-icon [icon]="faTrash" />
          Zeitraum löschen
        </button>
      </div>
    </div>

    <!-- AG-Grid: Klärfälle -->
    <div class="relative flex-1 min-h-0 px-3 pb-1">
      <ag-grid-angular
        class="ag-theme-quartz absolute inset-0 mx-3 mb-1"
        [rowData]="unclearRecords"
        [columnDefs]="unclearColDefs"
        [defaultColDef]="defaultColDef"
        [theme]="hawkTheme"
        [loadThemeGoogleFonts]="true"
        [localeText]="locale"
        [animateRows]="true"
        [suppressCellFocus]="true"
        (gridReady)="onUnclearGridReady($event)"
      />
    </div>
  </div>

<!-- === Popup: Rückbau-Artikel Erstellen/Bearbeiten === -->
@if (showForm()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (click)="cancelForm()">
    <div class="bg-base-100 rounded-lg shadow-xl w-full max-w-lg mx-4 p-5" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold">
          @if (editingArticleId()) {
            Rückbau-Artikel bearbeiten
          } @else {
            Neuer Rückbau-Artikel
          }
        </h3>
        <button class="bm-btn bm-btn-ghost bm-btn-sm bm-btn-square" (click)="cancelForm()">
          <fa-icon [icon]="faTimes" />
        </button>
      </div>

      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Standard-Disposition *</label>
        <select class="bm-select w-full" [(ngModel)]="formDisposition">
          <option value="" disabled>Bitte auswählen</option>
          <option value="disposal">Entsorgung</option>
          <option value="storage">Einlagerung</option>
          <option value="return">Rücksendung</option>
        </select>

        <!-- Artikelvorlage bei Einlagerung (Pflicht, Beschreibung wird übernommen) -->
        @if (formDisposition === 'storage') {
          <label class="bm-fieldset-label">Artikelvorlage *</label>
          <div class="relative">
            <div class="bm-join w-full">
              <input
                type="text"
                class="bm-join-item bm-input grow"
                placeholder="Artikelvorlage suchen..."
                [(ngModel)]="articleTemplateSearch"
                (input)="onTemplateSearchInput()"
                (focus)="onTemplateSearchInput()"
              />
              @if (selectedTemplateName) {
                <button class="bm-join-item bm-btn bm-btn-square bm-btn-ghost" (click)="clearTemplate()">
                  <fa-icon [icon]="faTimes" />
                </button>
              }
            </div>
            @if (showTemplateDropdown() && filteredTemplates().length > 0) {
              <div class="absolute z-50 mt-1 w-full bg-base-100 border border-base-300 rounded shadow-lg max-h-48 overflow-y-auto">
                @for (template of filteredTemplates(); track template.id) {
                  <button
                    class="w-full text-left px-3 py-2 hover:bg-base-200 text-sm"
                    (click)="selectTemplate(template)"
                  >
                    {{ template.description }}
                  </button>
                }
              </div>
            }
          </div>
          @if (!formArticleTemplateId) {
            <div class="text-error text-xs mt-1">Artikelvorlage ist bei Einlagerung erforderlich.</div>
          }
        }

        <!-- Beschreibung bei Entsorgung und Rücksendung (manuell) -->
        @if (formDisposition === 'disposal' || formDisposition === 'return') {
          <label class="bm-fieldset-label">Beschreibung *</label>
          <input
            type="text"
            class="bm-input w-full"
            placeholder="Beschreibung des Rückbau-Artikels"
            [(ngModel)]="formDescription"
          />
        }

        <!-- Entsorgungshinweis bei Entsorgung -->
        @if (formDisposition === 'disposal') {
          <label class="bm-fieldset-label">Entsorgungshinweis</label>
          <textarea
            class="bm-input w-full"
            rows="2"
            placeholder="Optionale Beschreibung zur Entsorgung"
            [(ngModel)]="formDisposalDescription"
          ></textarea>
        }

        <label class="bm-fieldset-label flex items-center gap-2 mt-2" [class.cursor-pointer]="!templateRequiresSn" [class.opacity-60]="templateRequiresSn">
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="formCaptureSns" [disabled]="templateRequiresSn" />
          Seriennummern erfassen
          @if (templateRequiresSn) {
            <span class="text-xs text-info">(durch Artikelvorlage vorgegeben)</span>
          }
        </label>
      </fieldset>

      <div class="flex justify-end gap-2 mt-4">
        <button class="bm-btn bm-btn-ghost" (click)="cancelForm()">
          Abbrechen
        </button>
        <button class="bm-btn bm-btn-primary" (click)="saveArticle()" [disabled]="!canSaveArticle()">
          <fa-icon [icon]="faSave" class="mr-1" />
          Speichern
        </button>
      </div>
    </div>
  </div>
}

<!-- === Popup: Bilder anzeigen === -->
@if (showImagePopup()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60" (click)="closeImagePopup()">
    <div class="bg-base-100 rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto p-5" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold">{{ imagePopupTitle() }}</h3>
        <button class="bm-btn bm-btn-ghost bm-btn-sm bm-btn-square" (click)="closeImagePopup()">
          <fa-icon [icon]="faTimes" />
        </button>
      </div>
      <div class="flex flex-col gap-4">
        @for (url of imagePopupUrls(); track url) {
          <img [src]="url" class="w-full rounded border border-base-300" />
        }
      </div>
    </div>
  </div>
}

<!-- === Popup: Klärfall Artikel zuweisen === -->
@if (assigningRecordId() !== null) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (click)="cancelAssign()">
    <div class="bg-base-100 rounded-lg shadow-xl w-full max-w-md mx-4 p-5" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold">Artikel zuweisen</h3>
        <button class="bm-btn bm-btn-ghost bm-btn-sm bm-btn-square" (click)="cancelAssign()">
          <fa-icon [icon]="faTimes" />
        </button>
      </div>

      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Rückbau-Artikel auswählen</label>
        <select class="bm-select w-full" [(ngModel)]="selectedArticleIdForAssign">
          <option [ngValue]="null" disabled>Artikel wählen...</option>
          @for (article of articles; track article.id) {
            <option [ngValue]="article.id">{{ article.description }}</option>
          }
        </select>
      </fieldset>

      <div class="flex justify-end gap-2 mt-4">
        <button class="bm-btn bm-btn-ghost" (click)="cancelAssign()">
          Abbrechen
        </button>
        <button
          class="bm-btn bm-btn-primary"
          [disabled]="!selectedArticleIdForAssign"
          (click)="confirmAssign(assigningRecordId()!)"
        >
          <fa-icon [icon]="faSave" class="mr-1" />
          Zuweisen
        </button>
      </div>
    </div>
  </div>
}

<!-- Popup: Klärfälle nach Zeitraum löschen -->
@if (showBulkDeleteDialog()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (click)="showBulkDeleteDialog.set(false)">
    <div class="bg-base-100 rounded-lg shadow-xl w-full max-w-md mx-4 p-5" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold">Klärfälle nach Zeitraum löschen</h3>
        <button class="bm-btn bm-btn-ghost bm-btn-sm bm-btn-square" (click)="showBulkDeleteDialog.set(false)">
          <fa-icon [icon]="faTimes" />
        </button>
      </div>

      <div class="flex items-center gap-2">
        <fieldset class="bm-fieldset flex-1">
          <label class="bm-fieldset-label">Von</label>
          <input type="date" class="bm-input w-full" [(ngModel)]="bulkDeleteFrom" />
        </fieldset>
        <fieldset class="bm-fieldset flex-1">
          <label class="bm-fieldset-label">Bis</label>
          <input type="date" class="bm-input w-full" [(ngModel)]="bulkDeleteTo" />
        </fieldset>
      </div>
      <p class="text-xs text-base-content/60 mt-1">Beide Felder optional — leer = alle Klärfälle.</p>

      <label class="flex items-center gap-2 mt-4 cursor-pointer">
        <input type="checkbox" class="bm-checkbox" [ngModel]="bulkDeleteOnlyUnassigned()"
               (ngModelChange)="bulkDeleteOnlyUnassigned.set($event)" />
        <span class="text-sm">Nur nicht zugewiesene löschen</span>
      </label>
      <p class="text-xs text-base-content/60 mt-1">Bereits einer Artikelvorlage zugewiesene Klärfälle bleiben erhalten.</p>

      <div class="flex justify-end gap-2 mt-5">
        <button class="bm-btn bm-btn-ghost" (click)="showBulkDeleteDialog.set(false)">Abbrechen</button>
        <button class="bm-btn bm-btn-error" [disabled]="bulkDeleting()" (click)="bulkDeleteUnclear()">
          <fa-icon [icon]="faTrash" class="mr-1" />
          Löschen
        </button>
      </div>
    </div>
  </div>
}
